<template>
  <div class="row">
    <div class="col-12">
      <card>
        <vue-element-loading
          :text="loading.text"
          spinner="bar-fade-scale"
          :color="loading.color"
          :active="loading.active"
          :is-full-screen="false"/>
        <div>
          <div class="col-sm-12 card">
            <el-table stripe
                      style="width: 100%;"
                      :data="tableData"
                      size="mini">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Actions">
                <template slot-scope="props">
                  <a v-tooltip.top-center="'Editar'" class="px-1 btn-info btn-simple btn-link"
                     @click="update(props.row)">
                    <i class="fa fa-align-justify"></i>
                  </a>
                  <a v-tooltip.top-center="'Eliminar'" class="px-1 btn-danger btn-simple btn-link"
                     @click="showSwal('delete', props.row.id)">
                    X
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </card>
    </div>
    <el-dialog
      center
      :visible.sync="change"
      :append-to-body="true"
      :modal-append-to-body="false">
      <div>
        <form id="edit_form">
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        label="Nombre"
                        placeholder="Nombre del Identificador"
                        v-model="device.name"
                        v-validate="modelValidations.name"
                        name="name"
                        :error="getError('name')"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
              Editar Identificador
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {Dialog, Option, Select, Table, TableColumn} from 'element-ui'
  import {Pagination as LPagination} from 'src/components/index'
  import vueElementLoading from 'vue-element-loading'

  export default {
    components: {
      LPagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      vueElementLoading,
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        users: [],
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        contacts: [],
        change: false,
        searchQuery: '',
        propsToSearch: ['email'],
        tableColumns: [
          {
            prop: 'name',
            label: 'Nombre',
            minWidth: 150
          },
        ],
        tableData: [],
        device: {
          name: '',
          identifier: ''
        },
        account: {},
        modelValidations: {
          name: {
            required: true
          },
        }
      }
    },
    methods: {
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid)
            this.addDevice();
        })
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      changePage() {
        this.loadUsers()
      },
      loadUsers() {
        this.loading.active = true
        this.axios({
          url: `conexions.php?datos=3`,
          method: 'get',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.tableData = response.data.message
          })
          .catch(error => {
            this.loading.active = false
          })
      },
      handleDelete(id) {
        this.loading.active = true
        this.axios({
          url: `conexions.php?deleteIdentifier=${id}`,
          method: 'delete',
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.loadUsers()
            swal({
              title: 'Deleted!',
              text: response.message,
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
          .catch(error => {
            this.loading.active = false
            swal({
              title: 'Deleted!',
              text: error.response.message,
              type: 'error',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
          })
      },
      update(id) {
        this.change = true
        this.device.name = id.name;
        this.device.identifier = id.id;
      },
      showSwal(type, id) {
        if (type === 'delete') {
          swal({
            title: '¿Esta seguro?',
            text: `Esta operación no puede ser revertida!`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Eliminar',
            buttonsStyling: false
          }).then((action) => {
            if (action.value) {
              this.handleDelete(id)
            }
          })
        }
      },
      addDevice() {
        this.loading.active = true
        this.axios({
          url: `conexions.php`,
          method: 'put',
          data: this.device,
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.change = false
            this.clearModel()
            this.loadUsers()
            this.showSwal('success', 'Institucion Modificada')
          })
          .catch(error => {
            this.loading.active = false
            this.showSwal('error', error.response.data.messages)
          })
      },
      clearModel() {
        this.device = {
          name: '',
          identifier: ''
        }
      }
    },
    created() {
      this.loadUsers(1)
    },
    mounted() {
    },
    watch: {
      searchQuery(value) {
        this.loadUsers(1)
      }
    }
  }
</script>
<style>
</style>
